/*
  提交按钮的loading控制
*/

export const makeSure = {
  methods: {
    makeSureEvent(cb, row = null, text = '是否确定操作？',options={}){
        this.$confirm(text,options)
        .then(_ => {
          // done();
          cb(row)
        })
        .catch(_ => {
            this.$message('取消操作');
        });
    }
  },
}
